module.exports = __webpack_public_path__ + "img/icon26.2fc01d17.b4ccf5ae.svg";